// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"76aa0ac0","302":"16898412","369":"d925e847","389":"1678cd22"}[chunkId] + ".chunk.js";
};